import {makeStyles} from '@material-ui/core'

// @ts-ignore
export default makeStyles(theme => ({
  paper: (props: any) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 20,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flext-start',

    '& > .ReportsModalBody': {
      borderRight: props.extended ? `1px solid ${theme.palette.divider}` : undefined,
      borderRadius: 20,
    },
  }),
  close: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.text.primary,
  },
}))
